import { render, staticRenderFns } from "./UnclassifiedVerification.vue?vue&type=template&id=26f1ff6c&"
import script from "./UnclassifiedVerification.vue?vue&type=script&lang=js&"
export * from "./UnclassifiedVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports